/** Ported from src/components/ui/SectionLabel.tsx. */
export default function SectionLabel({ children }: { children: string }) {
  return <h2 className="type-micro section-label">{children}</h2>;
}
